import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { DynamicFormField, FormComponent } from '@teamfoster/dynamic-forms';
import { Filter } from '../../../shop';

@Component({
  selector: 'app-product-filters',
  templateUrl: './product-filters.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductFiltersComponent implements OnInit {
  @Input() filters?: Filter[];
  @Input() activeFilters?: any;
  @Input() initWithValue?: any;
  @ViewChild(FormComponent, { static: false }) form?: FormComponent;
  @Output() filtered = new EventEmitter<{ [key: string]: string }>();

  formFields: DynamicFormField[] = [];

  constructor(private fb: UntypedFormBuilder, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.formFields =
      this.filters?.map((filter, i) => {
        return {
          label: filter.label,
          name: filter.id.replace(/\./g, '-'),
          validators: [],
          fieldType: 'radio-list',
          order: i,
          value: this.initWithValue[filter.id.replace(/\./g, '-')],
          selectOptions: filter.values.map(value => {
            return {
              title: value.label,
              id: value.id,
            };
          }),
          groupOpen: !!this.initWithValue[filter.id.replace(/\./g, '-')],
        };
      }) || [];
  }

  reset() {
    this.form?.form.reset();
    this.cd.detectChanges();
  }
}
